import isNil from 'lodash/isNil'

// This is a helper function that validates the format of the IBAN
// IBAN is a standard international bank account number
// It must start with a 2-letter country code, followed by 2 digits, and then up to 30 alphanumeric characters
export const isValidIban = (iban?: string): boolean => {
  if (isNil(iban)) return false
  const formattedIban = iban.toUpperCase()
  const ibanRegex = /^[A-Z]{2}\d{2}[A-Z0-9]{1,30}$/
  return ibanRegex.test(formattedIban)
}

// This is a helper function that validates the format of the SWIFT
// SWIFT is a standard international bank identifier code
// It must start with a 6-letter bank code, followed by 2 letters or digits, and then up to 3 letters or digits
export const isValidSwift = (swift?: string): boolean => {
  if (isNil(swift)) return false
  const formattedSwift = swift.toUpperCase()
  const swiftRegex = /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/
  return swiftRegex.test(formattedSwift)
}

// This is a helper function that validates the format of the ABA
// ABA (or RTN) is a US routing number similar to an english sort code.
// It must be a 9-digit string
export const isValidAba = (aba?: string): boolean => {
  if (isNil(aba)) return false

  const formattedAba = aba.replace(/\s/g, '')
  const abaRegex = /^\d{9}$/
  return abaRegex.test(formattedAba)
}
